import { useMantineColorScheme } from '@mantine/core';

export const getLogoSvg = () => {
  const { colorScheme: currentScheme } = useMantineColorScheme();
  return currentScheme === 'dark'
    ? '/imgs/logo/brasil-arena-dark.svg'
    : '/imgs/logo/brasil-arena-light.svg';
};
